export const GET_RANDOM_QUOTE = 'GET_RANDOM_QUOTE'